import { Dropdown, Image } from "react-bootstrap";
import "../../style/menu.css";
import { useContext, useEffect, useState } from "react";
import GlobalContext from "../../context/GlobalContext";
import { ChevronDown, LogOut, Settings } from "lucide-react";
import { useNavigate } from "react-router-dom";
import swal from "../../services/swalConfig";
import defaultProfilePicture from "../../assets/images/icon/default_profile.jpeg";
import { useTranslation } from "react-i18next";

/**
 * Menu profil di header (avatar → nama, departemen, email, pengaturan, keluar).
 */
const NavbarProfileComponent = () => {
  const { user, logoutApiCall } = useContext(GlobalContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [profileSrc, setProfileSrc] = useState(
    user?.picture || defaultProfilePicture,
  );

  useEffect(() => {
    setProfileSrc(user?.picture || defaultProfilePicture);
  }, [user?.picture]);

  const handleLogout = async () => {
    const result = await swal.fire({
      title: "",
      text: t("profile.logout_confirm"),
      icon: "warning",
      showCancelButton: false,
      confirmButtonText: t("profile.logout_yes"),
      confirmButtonColor: "#f10f29ff",
      cancelButtonText: t("actions.cancel"),
      timer: false,
    });

    if (result.isConfirmed) {
      logoutApiCall();
    }
  };

  const fullName = `${user?.first_name || ""} ${user?.last_name || ""}`.trim();
  const department = user?.workspace?.department || t("profile.no_department");
  const email = user?.user_email || user?.email;

  return (
    <Dropdown align="end" className="topbar-profile">
      <Dropdown.Toggle as="button" type="button" className="topbar-profile__toggle" aria-label={fullName}>
        <Image
          className="topbar-profile__avatar"
          src={profileSrc}
          onError={() => setProfileSrc(defaultProfilePicture)}
          roundedCircle
          alt=""
        />
        <span className="topbar-profile__meta">
          <span className="topbar-profile__name">{fullName}</span>
          <span className="topbar-profile__department">{department}</span>
        </span>
        <ChevronDown size={16} className="topbar-profile__chevron" aria-hidden="true" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="topbar-profile__menu">
        <div className="topbar-profile__header">
          <div className="topbar-profile__header-name">{fullName}</div>
          {email && <div className="topbar-profile__header-email">{email}</div>}
          <div className="topbar-profile__header-department">{department}</div>
        </div>
        <Dropdown.Item onClick={() => navigate("/settings")}>
          <Settings size={16} aria-hidden="true" /> {t("menu.settings")}
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item className="topbar-profile__logout" onClick={handleLogout}>
          <LogOut size={16} aria-hidden="true" /> {t("profile.sign_out")}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NavbarProfileComponent;
